// Load utils
import { debounce, updateLayoutVars, setCSSVar } from "./tools/utils";
import { gridDebug } from "./tools/gridDebug";

// Load components
import { BurgerMenu } from "./components/burgerMenu";

import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	// if (themeVars.is_dev) gridDebug.init();

	// update layout vars
	updateLayoutVars();
	window.addEventListener("resize", debounce(updateLayoutVars, 150));

	// Init components
	BurgerMenu.init();

	// Sitcky header
	const header = document.querySelector(".header");
	const headerTop = header.getBoundingClientRect().top;

	setCSSVar("--_header-h", `${header.offsetHeight}px`, "html");

	window.addEventListener("scroll", () => header.classList.toggle("is-sticky", window.scrollY > headerTop + header.offsetHeight));

	// Détection device "no touch" (mouse réelle)
	const isNoTouchDevice = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

	if (isNoTouchDevice) {
		const mainCursor = document.querySelector(".custom-cursor");
		const trailCursor = document.querySelector(".cursor-trail");
		const interactiveElements = 'a, button, input, textarea, select, [role="button"], [tabindex]:not([tabindex="-1"]), [data-anchor]';

		let mouseX = 0,
			mouseY = 0;
		let mainX = 0,
			mainY = 0;
		let trailX = 0,
			trailY = 0;

		// Vitesse
		const mainSpeed = 0.25;
		const trailSpeed = 0.1;

		document.addEventListener("mousemove", (e) => {
			mouseX = e.clientX;
			mouseY = e.clientY;
		});

		// Centrage initial GSAP
		gsap.set([mainCursor, trailCursor], { xPercent: -50, yPercent: -50 });

		// Animation smooth
		gsap.ticker.add(() => {
			mainX += (mouseX - mainX) * mainSpeed;
			mainY += (mouseY - mainY) * mainSpeed;
			gsap.set(mainCursor, { x: mainX, y: mainY });

			trailX += (mouseX - trailX) * trailSpeed;
			trailY += (mouseY - trailY) * trailSpeed;
			gsap.set(trailCursor, { x: trailX, y: trailY });
		});

		// Hover
		document.querySelectorAll(interactiveElements).forEach((el) => {
			el.addEventListener("mouseenter", () => mainCursor.classList.add("hovering"));
			el.addEventListener("mouseleave", () => mainCursor.classList.remove("hovering"));
		});
	}

	new PerformanceObserver((list) => {
		const latestEntry = list.getEntries().at(-1);

		if (latestEntry?.element?.getAttribute("loading") == "lazy") {
			console.warn("Warning: LCP element was lazy loaded", latestEntry);
		}
	}).observe({ type: "largest-contentful-paint", buffered: true });
});
